import { useEffect, useState } from 'react';

const FAVORITES_KEY = 'sigua-favorites';

function readFavorites(): string[] {
  try {
    const raw = localStorage.getItem(FAVORITES_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((item) => typeof item === 'string') : [];
  } catch {
    return [];
  }
}

export function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    setFavorites(readFavorites());
    const onStorage = () => setFavorites(readFavorites());
    window.addEventListener('storage', onStorage);
    window.addEventListener('sigua-favorites-change', onStorage);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('sigua-favorites-change', onStorage);
    };
  }, []);

  const persist = (next: string[]) => {
    setFavorites(next);
    try {
      localStorage.setItem(FAVORITES_KEY, JSON.stringify(next));
    } catch {
      // ignore storage errors
    }
    window.dispatchEvent(new Event('sigua-favorites-change'));
  };

  const toggleFavorite = (id: string) => {
    const current = readFavorites();
    const next = current.includes(id)
      ? current.filter((item) => item !== id)
      : [...current, id];
    persist(next);
    return next.includes(id);
  };

  const isFavorite = (id: string) => favorites.includes(id);

  return { favorites, isFavorite, toggleFavorite };
}

export function formatDate(date: string) {
  const [y, m, d] = date.split('-');
  return `${y}.${m}.${d}`;
}